<template>
    <modal name="create_booking_disabled_date" height="auto" scrollable adaptive>
        <app-card :title="$t('Create locked date in booking')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="store(validate)">
                    <app-datepicker v-model="form.date">
                        <template #label>
                            {{ $t('Date') }}
                        </template>
                    </app-datepicker>
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Save') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import BookingDisabledDateService from '@services/bookingLockedDate.service';
import moment from 'moment';

export default {
    data() {
        return {
            form:{
                date: moment(new Date()).format('L')
            },
            loading: false
        };
    },
    methods: {
        store(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    BookingDisabledDateService.store(this.form).then(res => {
                        this.$toastr.s(this.$t('Saved'));
                        this.loading = false;
                        this.$emit('setDate', res);
                        this.hide();
                    });
                }
            });
        },
        hide() {
            this.$modal.hide('create_booking_disabled_date');
        }
    }
};
</script>
